import styled from 'styled-components';
import { PRESSABLE } from '../../styles/constants';
import { prop } from '../../util/prop';
import { Link } from '../Link';

export const StyledSvg = styled.svg<{ height: number }>`
  flex: 1;
  height: ${prop('height')}px;
  width: auto;
`;

export const StyledLink = styled(Link)`
  ${PRESSABLE}

  &:hover {
    filter: brightness(1.2);
  }
`;
